"use strict";
// THIS CODE WAS AUTOMATICALLY GENERATED
// DO NOT EDIT THIS CODE BY HAND
// RUN THE FOLLOWING COMMAND FROM THE WORKSPACE ROOT TO REGENERATE:
// npx nx generate-lib repo
Object.defineProperty(exports, "__esModule", { value: true });
exports.es2021_weakref = void 0;
const base_config_1 = require("./base-config");
exports.es2021_weakref = {
    WeakRef: base_config_1.TYPE_VALUE,
    WeakRefConstructor: base_config_1.TYPE,
    FinalizationRegistry: base_config_1.TYPE_VALUE,
    FinalizationRegistryConstructor: base_config_1.TYPE,
};
//# sourceMappingURL=es2021.weakref.js.map